import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  header: {
    display: 'block',
    width: '100%',
    alignItems: 'center',

    '@media (min-width:356px)': {
      display: 'inline-flex'
    }
  },

  headerContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  headerBtnContainer: {
    display: 'flex',
    paddingLeft: 16,
    gap: 10,

    '& > button': {
      width: 'max-content'
    },

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap',
      width: '100%',
      flexDirection: 'column'
    }
  },

  pageContainer: {
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    }
  },

  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2)
    }
  },

  buttonIcon: {
    marginRight: theme.spacing(1),
    fontSize: 18
  },

  // Main title
  title: {
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 16
  },

  // Section (Card) - seguindo padrão PregnancyDiagnosis
  section: {
    border: '1px solid ' + theme.palette.divider,
    borderRadius: 8,
    padding: 16,
    backgroundColor: theme.palette.background.paper
  },

  sectionTitle: {
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  formContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: 16
  },

  formGroup: {
    '& .MuiFormLabel-root': {
      fontSize: 10,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: 1.5,
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1)
    }
  },

  // Progress Section
  progressSection: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`
  },

  progressHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5)
  },

  progressLabel: {
    color: theme.app.colors.text.primary,
    fontSize: 14,

    opacity: 0.7
  },

  progressStats: {
    display: 'flex',
    alignItems: 'center'
  },

  progressCount: {
    fontSize: 12,
    fontWeight: 700,
    color: theme.palette.primary.main
  },

  completedBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 8px',
    borderRadius: 12,
    backgroundColor: alpha(theme.palette.success.main, 0.1)
  },

  completedIcon: {
    fontSize: 16,
    color: theme.palette.success.main
  },

  completedText: {
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 1,
    color: theme.palette.success.main
  },

  progressBarContainer: {
    width: '100%',
    height: 8,
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: alpha(theme.palette.grey[500], 0.1)
  },

  progressBar: {
    height: 8,
    backgroundColor: 'transparent',
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 4
    }
  },

  progressBarComplete: {
    height: 8,
    backgroundColor: 'transparent',
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.success.main,
      borderRadius: 4
    }
  },

  userInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    borderRadius: 12,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
  },

  userIcon: {
    color: alpha(theme.palette.primary.main, 0.6),
    fontSize: 24
  },

  userLabel: {
    color: theme.app.colors.text.primary,
    fontSize: 14,
    marginBottom: 2
  },

  userName: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    fontSize: 14
  },

  cardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`
  },

  statusLabel: {
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 1.5,
    color: theme.palette.text.primary,
    opacity: 0.7
  },

  statusChip: {
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    color: theme.palette.success.main,
    fontWeight: 700,
    fontSize: 9,
    letterSpacing: 1.2,
    height: 24,
    '& .MuiChip-label': {
      padding: '0 10px'
    }
  },

  // Records list
  recordsCount: {
    fontSize: 14,
    fontWeight: 500,
    color: '#000',
    opacity: 0.7
  },

  recordsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 16,
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'auto',
    paddingRight: 4,
    '&::-webkit-scrollbar': {
      width: 6
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.divider,
      borderRadius: 3
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.main,
      borderRadius: 3,
      '&:hover': {
        background: alpha(theme.palette.primary.main, 0.8)
      }
    }
  },

  recordItem: {
    display: 'flex',
    alignItems: 'center',
    padding: 12,
    gap: 12,
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04)
    }
  },

  recordIcon: {
    width: 40,
    height: 40,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      color: theme.palette.primary.main,
      fontSize: 20
    }
  },

  recordInfo: {
    flex: 1,
    minWidth: 0
  },

  recordLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: '#000',
    opacity: 0.8,
    display: 'block',
    marginBottom: 4
  },

  recordNumber: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontSize: 16
  },

  recordMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: 8
    }
  },

  recordTag: {
    textAlign: 'right',
    minWidth: 80
  },

  recordTagValue: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    fontSize: 14
  },

  recordStatus: {
    minWidth: 90,
    display: 'flex',
    justifyContent: 'flex-end'
  },

  statusAvailable: {
    backgroundColor: alpha(theme.palette.success.main, 0.15),
    color: theme.palette.success.main,
    fontWeight: 700,
    fontSize: 9,
    letterSpacing: 1.2,
    borderRadius: 5,
    height: 24,
    textTransform: 'uppercase',
    '& .MuiChip-label': {
      padding: '0 10px'
    }
  },

  statusUsed: {
    backgroundColor: alpha(theme.palette.grey[500], 0.2),
    color: theme.palette.grey[700],
    fontWeight: 700,
    fontSize: 9,
    letterSpacing: 1.2,
    borderRadius: 5,
    height: 24,
    textTransform: 'uppercase',
    '& .MuiChip-label': {
      padding: '0 10px'
    }
  },

  deleteButton: {
    color: theme.palette.error.main,
    opacity: 0.7,
    transition: 'all 0.2s ease',
    '&:hover': {
      opacity: 1,
      backgroundColor: alpha(theme.palette.error.main, 0.1)
    }
  },

  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(6, 2),
    minHeight: 200
  },

  emptyStateContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    textAlign: 'center'
  },

  emptyStateIcon: {
    fontSize: 48,
    color: theme.palette.primary.main,
    opacity: 0.3,
    marginBottom: 8
  },

  emptyMessage: {
    fontSize: 18,
    fontWeight: 500,
    color: theme.palette.primary.main
  },

  emptyMessageSubtitle: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.primary.main,
    opacity: 0.7
  },

  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  }
}))
